import {memo} from 'react';
import {useMount, useUnmount} from 'react-use';
import {useSWRConfig} from 'swr';

import {PUBLIC_PATH} from '../../constants/system';
import {routeHistory} from '../../helpers/history';

const RouteGuard = memo(function RouteGuard() {
  const {cache} = useSWRConfig();

  // eslint-disable-next-line no-empty-function
  let unlisten = () => {};

  useMount(() => {
    unlisten = routeHistory.listen(({location, action}) => {
      if (
        location.pathname === `${PUBLIC_PATH}/login` &&
        action === 'REPLACE'
      ) {
        cache.clear();
      }
    });
  });

  useUnmount(() => {
    unlisten();
  });

  return null;
});

export default RouteGuard;
